import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../store';
import { setCredentials, logout as logoutAction, setLoading, setError } from '../store/slices';

/**
 * Hook for authentication state and actions.
 */
export function useAuth() {
  const dispatch = useAppDispatch();
  const { user, token, isAuthenticated, isLoading, error } = useAppSelector(
    (state) => state.auth
  );

  const login = useCallback(
    async (email: string, _password: string) => {
      dispatch(setLoading(true));
      try {
        // TODO: Integrate with Amazon Cognito
        // For now, mock the login flow
        dispatch(
          setCredentials({
            user: { id: '1', email, name: email.split('@')[0] },
            token: 'mock-jwt-token',
          })
        );
      } catch (err) {
        dispatch(setError(err instanceof Error ? err.message : 'Login failed'));
      }
    },
    [dispatch]
  );

  const logout = useCallback(() => {
    dispatch(logoutAction());
  }, [dispatch]);

  return {
    user,
    token,
    isAuthenticated,
    isLoading,
    error,
    login,
    logout,
  };
}
